module.exports = __webpack_public_path__ + "img/tittle_bg_l.a1c3e676.png";